var DiscoverWheel = /** @class */ (function () {
    function DiscoverWheel() {
    }
    return DiscoverWheel;
}());
export { DiscoverWheel };
var DiscoverItem = /** @class */ (function () {
    function DiscoverItem() {
    }
    DiscoverItem.GetItemUrl = function (item) {
        if (item.content.readableUrl && item.content.readableUrl.trim().length > 0) {
            return '/' + item.type + '/' + item.content.readableUrl;
        }
        return '/' + item.type + '/' + item.content.id;
    };
    return DiscoverItem;
}());
export { DiscoverItem };
var WheelContent = /** @class */ (function () {
    function WheelContent() {
    }
    return WheelContent;
}());
export { WheelContent };
